import { autocomplete, debouncedAutocomplete } from "./autocomplete";
import { getPlaceDetails } from "./details";
export default {
  autocomplete: autocomplete,
  debouncedAutocomplete: debouncedAutocomplete,
  getPlaceDetails: getPlaceDetails
};